/* tslint:disable */
/* eslint-disable */

/**
 * 805290000 = Nochnichtvorhanden (Noch nicht vorhanden)
 * 
 * 805290001 = Freistellungsbescheid (Freistellungsbescheid)
 * 
 * 100000000 = _60aBescheid (§60a Bescheid)
 * 
 * 100000001 = Auslandsprufvermerk (Auslandsprüfvermerk)
 * 
 * 805290004 = KorperschaftoffentlichenRechts (Körperschaft öffentlichen Rechts)
 */
import {EnumValue} from "@/core/models/enumvalue.model"
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export enum GlobalEnumsAceGemeinnuetzigkeit {
 Nochnichtvorhanden = 805290000,
 Freistellungsbescheid = 805290001,
 _60aBescheid = 100000000,
 Auslandsprufvermerk = 100000001,
 KorperschaftoffentlichenRechts = 805290004
}

marker([
    "Enum.GlobalEnumsAceGemeinnuetzigkeit.Nochnichtvorhanden",
    "Enum.GlobalEnumsAceGemeinnuetzigkeit.Freistellungsbescheid",
    "Enum.GlobalEnumsAceGemeinnuetzigkeit._60aBescheid",
    "Enum.GlobalEnumsAceGemeinnuetzigkeit.Auslandsprufvermerk",
    "Enum.GlobalEnumsAceGemeinnuetzigkeit.KorperschaftoffentlichenRechts"
]);

export namespace GlobalEnumsAceGemeinnuetzigkeit
{
    class DataSets
    {
        static GlobalEnumsAceGemeinnuetzigkeitDataSet: Array<EnumValue> = new Array<EnumValue>(
            new EnumValue("Nochnichtvorhanden", 805290000, "Noch nicht vorhanden"),
            new EnumValue("Freistellungsbescheid", 805290001, "Freistellungsbescheid"),
            new EnumValue("_60aBescheid", 100000000, "§60a Bescheid"),
            new EnumValue("Auslandsprufvermerk", 100000001, "Auslandsprüfvermerk"),
            new EnumValue("KorperschaftoffentlichenRechts", 805290004, "Körperschaft öffentlichen Rechts"),
        )
    }

    export function getAsDataset() {
        return DataSets.GlobalEnumsAceGemeinnuetzigkeitDataSet;
    }
}
